import React, { useEffect, useRef, useState } from "react";
import ReactDatePicker from "react-datepicker";
import { ReactTransliterate } from "react-transliterate";
import { FIELD_REQUIRED } from "../labels/formLabels.json";
import { useNavigate } from "react-router-dom";

import { Modal, Button } from 'react-bootstrap';
import "react-transliterate/dist/index.css";
import "react-datepicker/dist/react-datepicker.css";
import { useDispatch, shallowEqual, useSelector } from "react-redux";
import {
  addNewContent,
  approveContent,
  getBearerListByDesignation,
  rejectContent,
  updateContent,
} from "../../AddNewContent/actions/addNewContentActions";
import { toastr } from "react-redux-toastr";
import { isUserAdmin, isUserApprover, isUserReviewer } from "../../auth/sessionManager";
import API from "../../../helpers/API";
import { openPdfInNewTab } from "../../../helpers/ShowPdf";
import ImageToDisplay from "./ImageToDisplay";
// import { FileURL } from "../../../common/constants/urlconst";
import { FileURL } from '../../../common/constants/endpoints';

import { hideLoader, showLoader } from "../../../common/actions/commonActions";
import { IconButton } from "@mui/material";
import { ArrowDownward, ArrowUpward } from "@mui/icons-material";

const OfficeBearerContent = ({
  formTitle,
  actionType = "create",
  selectedMid,
  publishedContentDetails,
  handleCancel,
  resetPageData,
  isDemo
}) => {
  const { designationList} = useSelector(
    (state) => state.addNewContent,
    shallowEqual
  );
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [mid, setMid] = useState(0);
  const [designation, setDesignation] = useState("")
  const [educationQualification, setEducationQualification] = useState("")
  const [educationQualificationMr, setEducationQualificationMr] = useState("")
  const [educationQualificationHin, setEducationQualificationHin] = useState("")
  const [joiningDate, setJoiningDate] = useState(new Date());
  const [retirementDate, setRetirementDate] = useState();

  const [descInEnglish, setDescInEnglish] = useState("");
  const [descInMarathi, setDescInMarathi] = useState("");
  const [descInHindi, setDescInHindi] = useState("");
  const [englishFile, setEnglishFile] = useState(null);
  const [hindiFile, setHindiFile] = useState(null);
  const [englishMessageFile, setEnglishMessageFile] = useState(null);
  const [marathiMessageFile, setMarathiMessageFile] = useState(null);
  const [hindiMessageFile, setHindiMessageFile] = useState(null);
  const [fileExpDate, setFileExpDate] = useState(new Date());  
  const [isAdvtActive, setIsAdvtActive] = useState(true);
  const [showInLatestUpdate, setShowInLatestUpdate] = useState(false);
  const [showInImpNotice, setShowInImpNotice] = useState(false);
  const [remark, setRemark] = useState("");
  const [sortingBearerList, setSortingBearerList] = useState([])
  const [bearerListByDesignation, setBearerListByDesignation] = useState(false)
 
  

  const [isTouched, setIsTouched] = useState({
    descInMarathi: false,
    descInEnglish: false,
  });
  const [errors, setErrors] = useState({});
  const [uploadOption, setUploadOption] = useState('each');
  const [previewUrl, setPreviewUrl] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const fileInputRef = useRef(null);
  const fileInputRef2 = useRef(null);
  const fileInputRef3 = useRef(null);
  const handleChange = (e) => {
    const { name, value } = e.target;
    setIsTouched((prevFormData) => ({
      ...prevFormData,
      [name]: true,
    }));
    setErrors((prevErrData) => ({
      ...prevErrData,
      [name]: true,
    }));
  };
  const isNotEmptyOrNull = (variable) => {
    return variable === null || variable === undefined || variable === "";
  };

  const isEmptyOrNull = (variable) => {
    return variable === null || variable === undefined || variable === "";
  };

  const handleRemarkChange = (event) => {
    setRemark(event.target.value);
  };

  const handleApprove = (e, id, action) => {
    e.preventDefault();
    dispatch(approveContent(id, action, resetPageData));
  };
  const handleReject = (e, id, action) => {
    e.preventDefault();
    dispatch(rejectContent(id, action, resetPageData));
  };

  const getDownloadLink = (e,fileId, language='english') =>{
    e.preventDefault();
    dispatch(showLoader())
    let tokent = sessionStorage.getItem('token')
    API.get(`/web/api/v1/admin/downloadFile/${language}/${fileId}`, {
      headers: {
        'Authorization': `Bearer ${tokent}`
      },
    }).then((res) => {
      if(res){
        openPdfInNewTab(res.data.pdfData,()=>{dispatch(hideLoader())})
      }else{
        dispatch(hideLoader())
        toastr.error(res.message)
      }
    }).catch((err)=>{
      dispatch(hideLoader())
      toastr.error(err.message)
    });
  }
  const getDownloadMessageLink = (e,fileId, language='english', message) =>{
    e.preventDefault();
    dispatch(showLoader())
    let tokent = sessionStorage.getItem('token')
    API.get(`/web/api/v1/downloadbearer/file/${language}/${message}/${fileId}`, {
      headers: {
        'Authorization': `Bearer ${tokent}`
      },
    }).then((res) => {
      if(res){
        openPdfInNewTab(res.data.pdfData,()=>{dispatch(hideLoader())})
      }else{
        toastr.error(res.message)
      }
    }).catch((err)=>{
      toastr.error(err.message)
    });
  }


  const handleUpdateClick = (e) => {
    e.preventDefault();
    let cm = sortingBearerList.findIndex((sm)=>sm.descInEnglish==publishedContentDetails.descInEnglish);
    const newErrors = {};
    if (isNotEmptyOrNull(descInEnglish)) {
      newErrors.descInEnglish = true;
    }
    if (isNotEmptyOrNull(descInMarathi)) {
      newErrors.descInMarathi = true;
    }
    
    if (isNotEmptyOrNull(descInHindi)) {
      newErrors.descInHindi = true;
    }
    if (isNotEmptyOrNull(joiningDate)) {
      newErrors.joiningDate = true;
    }
    if (showInLatestUpdate && isNotEmptyOrNull(fileExpDate)) {
      newErrors.fileExpDate = true;
    }
    setErrors(newErrors);
    if (!Object.values(newErrors).includes(true)) {
      let sortedMenu= sortingBearerList.length >0 ?sortingBearerList.map((ecol, index)=>{
        return {...ecol, displayOrder: index+1}
      }):[]
      let filteredMenu = sortedMenu.filter(item => item.descInEnglish !== "Current Bearer");
      dispatch(
        updateContent({
          mid,
          id:publishedContentDetails.id,
          officeBearerJoiningDate: joiningDate,
          officeBearerRetirementDate: retirementDate,
          officeBearerEducationalQualification:educationQualification,
          officeBearerEducationalQualificationMr:educationQualificationMr,
          officeBearerEducationalQualificationHin:educationQualificationHin,
          designation: designation,
          isImageUpdated: englishFile ? 1 : 0,
          englishFileName:  "",
          marathiFileName: "",
          englishMessageFile: englishMessageFile,
          marathiMessageFile: marathiMessageFile,
          hindiMessageFile,
          descInEnglish,
          descInMarathi,
          descInHindi,
          englishFile:englishFile,
          marathiFile:englishFile,
          hindiFile: englishFile,
          fileExpDate,
          showInLatestUpdate,
          showInImpNotice,
          isActive : isAdvtActive,
          remark,
          displayOrder : cm+1,
          bearerDisplayOrderDtoList: [...filteredMenu],
          isCommonFile : uploadOption === 'all' ? true : false
        }, resetPageData)
      );
    } else {
      toastr.warning("Please enter all required fields.");
    }
  };

  const handleCreateClick = (e) => {
    e.preventDefault();
    let cm = sortingBearerList.findIndex((sm)=>sm.descInEnglish=='Current Bearer');
    const newErrors = {};
    if (isNotEmptyOrNull(designation)) {
      newErrors.designation = true;
    }
    if (isNotEmptyOrNull(descInEnglish)) {
      newErrors.descInEnglish = true;
    }
    if (isNotEmptyOrNull(descInMarathi)) {
      newErrors.descInMarathi = true;
    }
    
    if (isNotEmptyOrNull(descInHindi)) {
      newErrors.descInHindi = true;
    }
    if (isNotEmptyOrNull(englishFile)) {
      newErrors.englishFile = true;
    }
    if (isNotEmptyOrNull(educationQualification)) {
      newErrors.educationQualification = true;
    }
    if (isNotEmptyOrNull(educationQualificationMr)) {
      newErrors.educationQualificationMr = true;
    }
    if (isNotEmptyOrNull(educationQualificationHin)) {
      newErrors.educationQualificationHin = true;
    }
    if (isNotEmptyOrNull(englishMessageFile)) {
      newErrors.englishMessageFile = true;
    }
    if (isNotEmptyOrNull(hindiMessageFile) && uploadOption === 'each') {
      newErrors.hindiMessageFile = true;
    }
    if (isNotEmptyOrNull(marathiMessageFile) && uploadOption === 'each') {
      newErrors.marathiMessageFile = true;
    }
    if (isNotEmptyOrNull(joiningDate)) {
      newErrors.joiningDate = true;
    }
    if (showInLatestUpdate && isNotEmptyOrNull(fileExpDate)) {
      newErrors.fileExpDate = true;
    }
    setErrors(newErrors);

    if (!Object.values(newErrors).includes(true)) {
      let sortedMenu= sortingBearerList.length >0 ?sortingBearerList.map((ecol, index)=>{
        return {...ecol, displayOrder: index+1}
      }):[]
      let filteredMenu = sortedMenu.filter(item => item.descInEnglish !== "Current Bearer");
      dispatch(
        addNewContent({
          mid,
          officeBearerJoiningDate: joiningDate,
          officeBearerRetirementDate: retirementDate,
          officeBearerEducationalQualification:educationQualification,
          officeBearerEducationalQualificationMr:educationQualificationMr,
          officeBearerEducationalQualificationHin:educationQualificationHin,
          designation: designation,
          isImageUpdated: englishFile ? 1 : 0,
          englishFileName:  "",
          marathiFileName: "",
          englishFile:englishFile,
          marathiFile:englishFile,
          hindiFile: englishFile,
          englishMessageFile: englishMessageFile,
          marathiMessageFile: marathiMessageFile,
          hindiMessageFile,
          descInEnglish,
          descInMarathi,
          descInHindi,
          fileExpDate,
          showInLatestUpdate,
          showInImpNotice,
          isActive : isAdvtActive,
          remark,
          displayOrder : cm+1,
          bearerDisplayOrderDtoList: [...filteredMenu],
          isCommonFile : uploadOption === 'all' ? true : false
        }, resetPageData)
      );
    } else {
      toastr.warning("Please enter all required fields.");
    }
  };

  useEffect(() => {
    setMid(selectedMid);
    {
      if (actionType === "editing" && publishedContentDetails) {
        setMid(publishedContentDetails.mid);
        setJoiningDate(
          publishedContentDetails.officeBearerJoiningDate &&
            new Date(publishedContentDetails.officeBearerJoiningDate)
        );
        setRetirementDate(
          publishedContentDetails.officeBearerRetirementDate &&
            new Date(publishedContentDetails.officeBearerRetirementDate)
        );
        setDescInEnglish(publishedContentDetails.descInEnglish);
        setDescInMarathi(publishedContentDetails.descMr);
        setDescInHindi(publishedContentDetails.descHin);
        setEducationQualification(publishedContentDetails.officeBearerEducationalQualification);
        setEducationQualificationMr(publishedContentDetails.officeBearerEducationalQualificationMr);
        setEducationQualificationHin(publishedContentDetails.officeBearerEducationalQualificationHin);
        setDesignation(publishedContentDetails.designation?.id)
        setFileExpDate(
          publishedContentDetails.fileExpDate &&
            new Date(publishedContentDetails.fileExpDate)
        );
        setShowInLatestUpdate(publishedContentDetails.showInLatestUpdate);
        setShowInImpNotice(publishedContentDetails.showInImpNotice);
        publishedContentDetails.isActive ? setIsAdvtActive(publishedContentDetails.isActive) :setIsAdvtActive(false)
        setRemark(publishedContentDetails.remark);
        publishedContentDetails.designation && dispatch(getBearerListByDesignation(publishedContentDetails.mid ,publishedContentDetails?.designation?.id, setBearerListByDesignation))
        window.scrollTo(0, 0);
      }
    }
  }, [selectedMid]);

  
  const handleMarathiFileUpload = (e) => {
    const file = e.target.files[0];
    if (file && file.type === 'application/pdf') {
      setMarathiMessageFile(file);
    } else {
      toastr.warning('Please upload a valid PDF file.');
      setMarathiMessageFile(null);
      setPreviewUrl(null);
      if (fileInputRef2.current) {
        fileInputRef2.current.value = ''; 
      }
    }
  };
  const handleEngFileUpload = (e) => {
    const file = e.target.files[0];
    if (file && file.type === 'application/pdf') {
      setEnglishMessageFile(file);
    } else {
      toastr.warning('Please upload a valid PDF file.');
      setEnglishMessageFile(null);
      setPreviewUrl(null);
      if (fileInputRef.current) {
        fileInputRef.current.value = ''; 
      }
    }
  };
  const handleHindiFileUpload = (e) => {
    const file = e.target.files[0];
    if (file && file.type === 'application/pdf') {
      setHindiMessageFile(file);
    } else {
      toastr.warning('Please upload a valid PDF file.');
      setHindiMessageFile(null);
      setPreviewUrl(null);
      if (fileInputRef3.current) {
        fileInputRef3.current.value = ''; 
      }
    }
  };

  const handlePreview = (language) =>{
    setShowModal(true);
    switch (language) {
      case 'marathi':
        marathiMessageFile && setPreviewUrl(URL.createObjectURL(marathiMessageFile));
        break;
      case 'english':
        englishMessageFile && setPreviewUrl(URL.createObjectURL(englishMessageFile));
        break;
      case 'hindi':
        hindiMessageFile && setPreviewUrl(URL.createObjectURL(hindiMessageFile));
        break;
      default:
        setPreviewUrl(null);
        break;
    }
 }

  const handleMoveUp = (index) => {
    if (index > 0) {
      const newData = [...sortingBearerList];
      [newData[index - 1], newData[index]] = [newData[index], newData[index - 1]];
      setSortingBearerList(newData);
    }
  };

  const handleMoveDown = (index) => {
    if (index < sortingBearerList.length - 1) {
      const newData = [...sortingBearerList];
      [newData[index], newData[index + 1]] = [newData[index + 1], newData[index]];
      setSortingBearerList(newData);
    }
  };
  useEffect(()=>{
    if(actionType === "editing"){
      if(bearerListByDesignation.length>0){
        let bearerList = bearerListByDesignation
        // bearerList[publishedContentDetails.displayOrder] = {mid:500, displayOrder:publishedContentDetails.designation.displayOrder, descInEnglish:"Current Bearer"}
        setSortingBearerList([...bearerList]);
      }
    }else{
      if(bearerListByDesignation){
        setSortingBearerList([...bearerListByDesignation,{mid:500, descInEnglish:"Current Bearer"}]);
      }
    }
      
      // setSortingMenuList([...mainMenuList,{mid:500, name:"Current Bearer"}]);
    },[bearerListByDesignation]);

  const handleDesignationChange = (e) =>{
    handleChange(e); 
    setDesignation(e.target.value);
    if(e.target.value !== ""){
      dispatch(getBearerListByDesignation(mid ,e.target.value, setBearerListByDesignation))
    }else{
      setBearerListByDesignation([]);
    }
  }
  const closeModal = () => {
    setShowModal(false);
    if (previewUrl) URL.revokeObjectURL(previewUrl);
    setPreviewUrl(null);
  };
  const handleFileChange = (value) =>{
    setHindiMessageFile(null); 
    setEnglishMessageFile(null); 
    setMarathiMessageFile(null); 
    setUploadOption(value)
    if (fileInputRef.current) {
      fileInputRef.current.value = '';
    }
  }
  return (
    <>
      <p></p>
      <form noValidate>
        <div className="form-row">
        {!isDemo && <h4>
            <span>
              {actionType !== "editing" ? "Creating new" : "Editing"}{" "}
            </span>
            {actionType !== "editing"
              ? formTitle
              : publishedContentDetails.contentName}
          </h4>}
        </div>
        <p></p>
        
        <div className="form-row">
          <div className="form-group col-5">
            <div>
              <label htmlFor="select-sub-menu">Select Designation</label>
              <span className="text-danger">*</span>
              <select
                className={`form-control ${
                  ((isTouched.designation && isEmptyOrNull(designation)) ||
                    (errors.designation && isEmptyOrNull(designation))) &&
                  "is-invalid"
                }`}
                id="select-sub-menu"
                name="designation"
                // placeholder="choose one"
                required
                value={designation}
                onChange={handleDesignationChange}
              >
                <option value={""}>Choose one...</option>
                {designationList &&
                  designationList.length > 0 &&
                  designationList.map((menu, index) => {
                    return (
                      <option key={index} value={menu.id}>
                        {menu.name}
                      </option>
                    );
                  })}
              </select>
            </div>
            {errors.designation && isEmptyOrNull(designation) && (
              <span className="text-danger">Field is Required</span>
            )}
          </div>
        </div>
        <div className="form-row">
          <div className="form-group col-5">
            <label htmlFor="descInEnglish">
              <span>Name (English)</span>
              {/* <span>Name of Examination</span> (English) */}
            </label>
            <span className="text-danger">*</span>
            <input
              className={`form-control ${
                ((isTouched.descInEnglish && isEmptyOrNull(descInEnglish)) ||
                  (errors.descInEnglish && isEmptyOrNull(descInEnglish))) &&
                "is-invalid"
              }`}
              id="descInEnglish"
              name="descInEnglish"
              placeholder="Name in English"
              length="30"
              type="text"
              value={descInEnglish}
              onChange={(e) => {
                setDescInEnglish(e.target.value);
              }}
              onBlur={handleChange}
              required
            />
            {errors.descInEnglish && isEmptyOrNull(descInEnglish) && (
              <span className="text-danger">Field is Required</span>
            )}
          </div>
        </div>
        <div className="form-row">
          <div className="form-group col-5">
            <label htmlFor="descInMarathi">
              <span>Name (Marathi)</span>
            </label>
            <span className="text-danger">*</span>
            <ReactTransliterate
              name="descInMarathi"
              value={descInMarathi}
              placeholder="Name in Marathi"
              onChangeText={(e) => {
                setDescInMarathi(e);
              }}
              onBlur={handleChange}
              lang="mr"
              className={`form-control ${
                ((isTouched.descInMarathi && isEmptyOrNull(descInMarathi)) ||
                  (errors.descInMarathi && isEmptyOrNull(descInMarathi))) &&
                "is-invalid"
              }`}
            />
            {errors.descInMarathi && isEmptyOrNull(descInMarathi) && (
              <span className="text-danger">Field is Required</span>
            )}
          </div>
        </div>
        <div className="form-row">
          <div className="form-group col-5">
            <label htmlFor="descInHindi">
              <span>Name (Hindi)</span>
            </label>
            <span className="text-danger">*</span>
            <ReactTransliterate
              name="descInHindi"
              value={descInHindi}
              placeholder="Name in Hindi"
              onChangeText={(e) => {
                setDescInHindi(e);
              }}
              onBlur={handleChange}
              lang="mr"
              className={`form-control ${
                ((isTouched.descInHindi && isEmptyOrNull(descInHindi)) ||
                  (errors.descInHindi && isEmptyOrNull(descInHindi))) &&
                "is-invalid"
              }`}
            />
            {errors.descInHindi && isEmptyOrNull(descInHindi) && (
              <span className="text-danger">Field is Required</span>
            )}
          </div>
        </div>
        <div className="form-row">
          <div className="form-group col-5">
            <label htmlFor="descInMarathi">
              <span>Education Qualification (English)</span>
              {/* <span>Name of Examination</span> (Marathi) */}
            </label>
            <span className="text-danger">*</span>
            <input
              className={`form-control ${
                ((isTouched.educationQualification && isEmptyOrNull(educationQualification)) ||
                  (errors.educationQualification && isEmptyOrNull(educationQualification))) &&
                "is-invalid"
              }`}
              id="educationQualification"
              name="educationQualification"
              placeholder="Education Qualification"
              length="30"
              type="text"
              value={educationQualification}
              onChange={(e) => {
                setEducationQualification(e.target.value);              }}
              onBlur={handleChange}
              required
            />
            {errors.educationQualification && isEmptyOrNull(educationQualification) && (
              <span className="text-danger">Field is Required</span>
            )}
          </div>
        </div>
        <div className="form-row">
          <div className="form-group col-5">
            <label htmlFor="descInMarathi">
              <span>Education Qualification (Marathi)</span>
            </label>
            <span className="text-danger">*</span>
            <ReactTransliterate
              name="educationQualification"
              value={educationQualificationMr}
              placeholder="Education Qualification in Marathi"
              onChangeText={(e) => {
                setEducationQualificationMr(e);
              }}
              onBlur={handleChange}
              lang="mr"
              className={`form-control ${
                ((isTouched.educationQualificationMr && isEmptyOrNull(educationQualificationMr)) ||
                  (errors.educationQualificationMr && isEmptyOrNull(educationQualificationMr))) &&
                "is-invalid"
              }`}
            />
            {errors.educationQualificationMr && isEmptyOrNull(educationQualificationMr) && (
              <span className="text-danger">Field is Required</span>
            )}
          </div>
        </div>
        <div className="form-row">
          <div className="form-group col-5">
            <label htmlFor="descInMarathi">
              <span>Education Qualification (Hindi)</span>
            </label>
            <span className="text-danger">*</span>
            <ReactTransliterate
              name="educationQualification"
              value={educationQualificationHin}
              placeholder="Education Qualification in Hindi"
              onChangeText={(e) => {
                setEducationQualificationHin(e);
              }}
              onBlur={handleChange}
              lang="mr"
              className={`form-control ${
                ((isTouched.educationQualificationHin && isEmptyOrNull(educationQualificationHin)) ||
                  (errors.educationQualificationHin && isEmptyOrNull(educationQualificationHin))) &&
                "is-invalid"
              }`}
            />
            {errors.educationQualificationHin && isEmptyOrNull(educationQualificationHin) && (
              <span className="text-danger">Field is Required</span>
            )}
          </div>
        </div>
        <div className="form-row">
          <div className="col-3">
            <label htmlFor="dateOfPublication">Date Of Joining</label>
            <span className="text-danger">*</span>
          </div>
          <div className="input-group col-2">
            <ReactDatePicker
              showIcon
              selected={joiningDate}
              onChange={(date) => setJoiningDate(date)}
              peekNextMonth
              showMonthDropdown
              showYearDropdown
              dateFormat="dd/MM/yyyy"
              dropdownMode="select"
              customInput={
                <input
                  className={`form-control ${
                    ((isTouched.joiningDate &&
                      isEmptyOrNull(joiningDate)) ||
                      (errors.joiningDate &&
                        isEmptyOrNull(joiningDate))) &&
                    "is-invalid"
                  }`}
                  id="dateOfPublication"
                  name="dateOfPublication"
                  placeholder="DD-MM-YYYY"
                  required
                  minLength="10"
                  maxLength="10"
                />
              }
            />
            {errors.joiningDate && isEmptyOrNull(joiningDate) && (
              <span className="text-danger">{FIELD_REQUIRED}</span>
            )}
          </div>
        </div>
        <div className="form-row mt-2 mb-2">
          <div className="col-3">
            <label htmlFor="dateOfPublication">Date Of Retirement</label>
          </div>
          <div className="input-group col-2">
            <ReactDatePicker
              showIcon
              selected={retirementDate}
              onChange={(date) => setRetirementDate(date)}
              peekNextMonth
              showMonthDropdown
              showYearDropdown
              dateFormat="dd/MM/yyyy"
              dropdownMode="select"
              customInput={
                <input
                  className={`form-control ${
                    ((isTouched.retirementDate &&
                      isEmptyOrNull(retirementDate)) ||
                      (errors.retirementDate &&
                        isEmptyOrNull(retirementDate))) &&
                    "is-invalid"
                  }`}
                  id="dateOfPublication"
                  name="dateOfPublication"
                  placeholder="DD-MM-YYYY"
                  // required
                  minLength="10"
                  maxLength="10"
                />
              }
            />
            {/* {errors.retirementDate && isEmptyOrNull(retirementDate) && (
              <span className="text-danger">{FIELD_REQUIRED}</span>
            )} */}
          </div>
        </div>
        {/* {actionType !== "editing" &&  */}
        {actionType === "editing" && (
          <div className="form-row">
            <div className="col-3">Previous Profile Image:</div>
            <div className="form-group col" style={{height: "100px"}}>
              <div className="custom-file">
                <img 
                  src={`${FileURL}${publishedContentDetails.id}`}
                  alt="profileimg_office_bearers" 
                  height="100" width="150" 
                />
              </div>
            </div>
          </div>
        )}
        <div className="form-row">
          <div className="col-3">
          {actionType == "editing" &&  <>Update profile image </>}
            {actionType !== "editing" && <>Select profile image <span className="text-danger">*</span></>}
          </div>
          <div className="form-group col">
            <ImageToDisplay selectedImage = {englishFile} setSelectedImage = {setEnglishFile} setErrors={setErrors} />
            {errors.englishFile && !englishFile && (
              <span className="text-danger">Please Select File</span>
            )}
          </div>
        </div>
        {/* } */}
        
       
        {/* message file */}
        {actionType === "editing" && (
          <div className="form-row">
            <div className="col-3">View/Download Previous Message Files:</div>
            <div className="form-group col">
              <div className="custom-file">
                <a
                  href="# "
                  onClick={(e) => {
                    getDownloadMessageLink(e, publishedContentDetails.id, "english", "message");
                  }}
                >
                  English <i className="fa fa-download"></i>
                </a>
                &nbsp;|&nbsp;
                <a
                  href="# "
                  onClick={(e) => {
                    getDownloadMessageLink(e, publishedContentDetails.id, "marathi", "message");
                  }}
                >
                  Marathi <i className="fa fa-download"></i>
                </a>
                &nbsp;|&nbsp;
                <a
                  href="# "
                  onClick={(e) => {
                    getDownloadMessageLink(e, publishedContentDetails.id, "hindi", "message");
                  }}
                >
                  Hindi <i className="fa fa-download"></i>
                </a>
              </div>
            </div>
          </div>
        )}
        {/* similer file to all */}
        <div className="form-row">
          <div className="form-group col-3 ml-2">
            <div className="form-check">
              <input
                className="form-check-input"
                type="radio"
                name="uploadOption"
                id="uploadOptionEach"
                value="each"
                checked={uploadOption === 'each'}
                onChange={(e) => {
                  handleFileChange(e.target.value)
                }}
              />
              <label className="form-check-label" htmlFor="uploadOptionEach">
                Different file per language
              </label>
            </div>
          </div>
          <div className="form-group col">
            <div className="form-check">
              <input
                className="form-check-input"
                type="radio"
                name="uploadOption"
                id="uploadOptionAll"
                value="all"
                checked={uploadOption === 'all'}
                onChange={(e) => {
                  handleFileChange(e.target.value)
                }}
              />
              <label className="form-check-label" htmlFor="uploadOptionAll">
                Same file for all languages
              </label>
            </div>
          </div>
        </div>
        <div className="form-row">
            <div className="col-3">
              {/* Select message file to upload (English) */}
              
              {`Select message file to upload ${uploadOption === 'each'? "(English)":''}`}
              <span className="text-danger">*</span>
            </div>
            <div className="form-group col">
              <div className="custom-file">
                <input
                  type="file"
                  name="fileUploadEnglish"
                  accept=".pdf"
                  onChange={handleEngFileUpload}
                  ref={fileInputRef}
                />
              {englishMessageFile && (
                <Button className="ml-1" variant="primary" size="sm" onClick={()=>handlePreview('english')}>
                  Preview PDF
                </Button>
              )}
              </div>
              {errors.englishMessageFile && !englishMessageFile && (
                <span className="text-danger">Please Select File</span>
              )}
            </div>
          </div>
        {/* )} */}
        {/* {actionType !== "editing" && ( */}
        
        {uploadOption === 'each' && (
          <div className="form-row">
            <div className="col-3">
              Select message file to upload (Marathi)
              <span className="text-danger">*</span>
            </div>
            <div className="form-group col">
              <div className="custom-file">
                <input
                  type="file"
                  name="marathiFile"
                  accept=".pdf"
                  onChange={handleMarathiFileUpload}
                  ref={fileInputRef2}
                />
                {marathiMessageFile && (
                  <Button variant="primary" size="sm" onClick={()=>handlePreview('marathi')}>
                    Preview PDF
                  </Button>
                )}
              </div>
              {errors.marathiMessageFile && !marathiMessageFile && (
                <span className="text-danger">Please Select File</span>
              )}
            </div>
          </div>
        )}
        {uploadOption === 'each' && (
          <div className="form-row">
            <div className="col-3">
              Select message file to upload (Hindi)
              <span className="text-danger">*</span>
            </div>
            <div className="form-group col">
              <div className="custom-file">
                <input
                  type="file"
                  name="hindiFile"
                  accept=".pdf"
                  onChange={handleHindiFileUpload}
                  ref={fileInputRef3}
                />
                {hindiMessageFile && (
                  <Button variant="primary" size="sm" onClick={()=>handlePreview('hindi')}>
                    Preview PDF
                  </Button>
                )}
              </div>
              {errors.hindiMessageFile && !hindiMessageFile && (
                <span className="text-danger">Please Select File</span>
              )}
            </div>
          </div>
        )} 
       
        <div className="form-row">
          <div className="col-3">Active</div>
          <div className="col">
            <input
              id="isAdvtActive"
              name="isAdvtActive"
              type="checkbox"
              onChange={(e) => setIsAdvtActive(e.target.checked)}
              checked={isAdvtActive}
            />
          </div>
        </div>
        <p></p>
        {/* bearer order */}
        { sortingBearerList && sortingBearerList.length>0 && <div className="row">
            <label className='pt-2 font-weight-bold'>Set and adjust display order:  </label><br/>
            <div className="table-responsive w-50">
              <table className="table dataTable p-0" id="datatable">
                <thead className=' font-weight-bold'> 
                  <tr>
                    <th className=''>Display Order</th>
                    <th className=''>Name</th>
                    <th className='text-center' style={{width:"80px"}}>Action</th>
                  </tr>
                </thead>
                <tbody>
                {sortingBearerList.map((ml, index)=>{
                  return <tr key={index}>
                    <td className='pt-2'>{index+1}</td>
                    <td className={`pt-2 ${actionType !== "editing" ? ml.descInEnglish=='Current Bearer'? 'text-danger': '': ml.descInEnglish === publishedContentDetails.descInEnglish? 'text-danger' : '' }`}>{ml.descInEnglish}</td>
                    <td className='p-0'>
                      <div className='p-0' style={{margin:"auto"}}>
                    <IconButton onClick={() => handleMoveUp(index)} disabled={actionType !== "editing" ? ml.descInEnglish!=='Current Bearer' : ml.descInEnglish !== publishedContentDetails.descInEnglish} color="primary" aria-label="add an alarm">
                      <ArrowUpward />
                    </IconButton>
                    <IconButton onClick={() => handleMoveDown(index)} disabled={actionType !== "editing" ? ml.descInEnglish!=='Current Bearer' : ml.descInEnglish !== publishedContentDetails.descInEnglish} color="primary" aria-label="add an alarm">
                      <ArrowDownward />
                    </IconButton>
                    </div>
                    </td>
                  </tr>
                })}
                </tbody>
              </table>
            </div>
          </div>}
        <div className="form-row">
          <div className="col-sm-12">
            <label htmlFor="remarksText">
              {" "}
              {actionType == "editing" && "Previous "}Remarks:
            </label>
            <textarea
              className="form-control"
              id="remarksText"
              name="remarksText"
              rows="3"
              value={remark}
              onChange={handleRemarkChange}
            ></textarea>
          </div>
        </div>
        <p></p>
        <hr className="dropdown-divider" />
        <p></p>
        <div className="form-row">
          <div className="col-sm-12">
            {(actionType !== "editing" && !isDemo) && (
              <>
                <button className="btn btn-primary" onClick={handleCreateClick}>
                  <i className="fa fa-check-circle">&nbsp;</i>Create
                </button>
                &nbsp;{" "}
              </>
            )}
            {actionType === "editing" && (
              <div>
                <button className="btn btn-primary" onClick={handleUpdateClick}>
                  <i className="fa fa-save">&nbsp;</i>Save
                </button>
                &nbsp;
                {(isUserReviewer() || isUserApprover() || isUserAdmin()) &&
                  publishedContentDetails.status &&
                  publishedContentDetails.status !== "APPROVED" && (
                    <button
                      className="btn btn-success"
                      onClick={(e) =>
                        handleApprove(e, publishedContentDetails.id, "Approve")
                      }
                    >
                      <i className="fa fa-times-circle">&nbsp;</i>Approve
                    </button>
                  )}
                &nbsp;
                {(isUserReviewer() || isUserApprover() || isUserAdmin()) &&
                  publishedContentDetails.status &&
                  publishedContentDetails.status !== "APPROVED" && (
                    <button
                      className="btn btn-danger"
                      onClick={(e) =>
                        handleReject(e, publishedContentDetails.id, "Reject")
                      }
                    >
                      <i className="fa fa-ban">&nbsp;</i>Reject
                    </button>
                  )}
                &nbsp;
                <button className="btn btn-dark" onClick={handleCancel}>
                  <i className="fa fa-times-circle">&nbsp;</i>Close
                </button>
              </div>
            )}
          </div>
        </div>
      </form>
       <Modal
          show={showModal}
          onHide={closeModal}
          size="lg"
          aria-labelledby="pdf-preview-modal"
          centered
        >
          <Modal.Header closeButton>
            <Modal.Title id="pdf-preview-modal">PDF Preview</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {previewUrl ? (
              <embed
                src={previewUrl}
                type="application/pdf"
                width="100%"
                height="600px"
              />
            ) : (
              <p>No PDF selected.</p>
            )}
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={closeModal}>
              Close
            </Button>
          </Modal.Footer>
        </Modal>     
      <div className="cover-spin"></div>
    </>
  );
};

export default OfficeBearerContent;
